// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function hoverBox1_click(event) {
	reta
	//Add your code for this event here: 
}